/**
 * Profile API Client - Player handles and display preferences
 */

import { http } from './http';

export interface PlayerProfile {
  wallet: string;
  handle: string | null;
  displayPreference: 'wallet' | 'handle';
  handleChanges: number;
  createdAt: string;
  updatedAt: string;
}

export async function getProfile(wallet: string): Promise<PlayerProfile> {
  return http.get<PlayerProfile>(`/profile/${wallet}`);
}

export async function registerHandle(
  wallet: string,
  handle: string,
): Promise<{ success: boolean; error?: string; handleChanges?: number }> {
  return http.post<{ success: boolean; error?: string; handleChanges?: number }>(
    `/profile/${wallet}/handle`,
    { handle },
  );
}

export async function updateDisplayPreference(
  wallet: string,
  preference: 'wallet' | 'handle',
): Promise<{ success: boolean }> {
  return http.post<{ success: boolean }>(`/profile/${wallet}/display-preference`, { preference });
}

export async function lookupByHandle(handle: string): Promise<{ wallet: string | null }> {
  return http.get<{ wallet: string | null }>(`/profile/lookup/${handle}`);
}

export async function resolveDisplayNames(
  wallets: string[],
): Promise<{ displayNames: Record<string, string> }> {
  return http.post<{ displayNames: Record<string, string> }>('/profile/resolve', { wallets });
}
